import { ButtonsModalSmallCentered, ModalMediumCentered } from '../../../../../../../../baseComponents/Modal'
import TwinTrans from '../../../../../../../../baseComponents/TwinTrans'
import { addDictionaryExtraLine, dictionaryComplexFromJsonArr, TwinDictionary } from '../../../../../../../../utils/globals/dictionary'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { FormRender } from '../../../../../../../../forms/FormRenderer/types'
import FormRenderer from '../../../../../../../../forms/FormRenderer'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { PaymentTypesPayload } from '../../../../../../../../utils/reducers/payments/paymentTypes'
import { PaymentMethodsPayload } from '../../../../../../../../utils/reducers/payments/paymentMethods'
import { twinFetchPostJSON } from '../../../../../../../../utils/globals/data'
import { BankRemittanceStatusInversed } from '@teinor/erp/types/company/accounting/bankRemittance'
import { ModalEditComponentPropsWithoutSubmit } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import { parsePresearchFiltersNewRemittance } from '../../Remittances/ModalNewRemittance/ModalFiltersNewRemittance/functions'
import './modalFiltersMarkRemittanceAsPaid.sass'

type ModalFiltersMarkRemittanceAsPaidProps = ModalFiltersMarkRemittanceAsPaidLogicProps & ModalEditComponentPropsWithoutSubmit & {
    paymentTypes: PaymentTypesPayload
    paymentMethods: PaymentMethodsPayload
}

const ModalFiltersMarkRemittanceAsPaid: React.FC<ModalFiltersMarkRemittanceAsPaidProps> = ({ paymentTypes, paymentMethods, setOpened, ...logic }) => {
    const {t} = useTwinTranslation()
    const { handleChangePresearchFilter, readyToSearch, dictRemittances } = useModalFiltersMarkRemittanceAsPaidLogic({ ...logic })
    const memoPaymentTypes = useMemo(() => addDictionaryExtraLine(JSON.parse(JSON.stringify(paymentTypes?.all))), [paymentTypes])
    const memoPaymentMethods = useMemo(() => addDictionaryExtraLine(JSON.parse(JSON.stringify(paymentMethods?.active || {}))), [paymentMethods])
    const fields: FormRender<any> = [
        {
            cols: 2,
            elements: [
                {
                    name: 'from',
                    label: t('from', 'Desde'),
                    component: 'InputCalendarStateFull',
                    onlyValids: true,
                    onChange: (value) => handleChangePresearchFilter('from', value),
                    className: 'text-left'
                },
                {
                    name: 'to',
                    label: t('to', 'Hasta'),
                    component: 'InputCalendarStateFull',
                    onlyValids: true,
                    onChange: (value) => handleChangePresearchFilter('to', value),
                    className: 'text-left'
                },
                {
                    name: 'PaymentMethodId',
                    label: t('paymentMethod', 'Método de pago'),
                    component: 'CustomSelectWithSearchBar',
                    onChange: (value) => handleChangePresearchFilter('PaymentMethodId', value),
                    sortItems: true,
                    items: memoPaymentMethods
                },
                {
                    name: 'PaymentTypeId',
                    label: t('paymentType', 'Tipo de pago'),
                    component: 'CustomSelectWithSearchBar',
                    onChange: (value) => handleChangePresearchFilter('PaymentTypeId', value),
                    sortItems: true,
                    items: memoPaymentTypes
                },
                {
                    name: 'BankRemittanceLot.BankRemittanceId',
                    label: t('remittance', 'Remesa'),
                    component: 'CustomSelectWithSearchBar',
                    onChange: (value) => handleChangePresearchFilter('BankRemittanceLot.BankRemittanceId', value),
                    sortItems: true,
                    items: addDictionaryExtraLine(dictRemittances || {})
                },
            ]
        }
    ]
    return (
        <ModalMediumCentered className='modal_filters_mark_remittance_as_paid' opened={true} setOpened={setOpened}>
            <h2><TwinTrans transKey='filterToMarkRemittanceAsPaid'>Filtrar para Marcar como pagados</TwinTrans></h2>
            <FormRenderer sections={fields} className='my-40'  />
            <ButtonsModalSmallCentered confirmText={t('search', 'Buscar')} onAccept={readyToSearch} setOpened={()=>{}} onCancel={()=>setOpened(null)} />
        </ModalMediumCentered>
    )
}

interface ModalFiltersMarkRemittanceAsPaidLogicProps {
    setPreSearchFilters: React.Dispatch<React.SetStateAction<TwinDictionary | null>>
}

const useModalFiltersMarkRemittanceAsPaidLogic = ({ setPreSearchFilters}: ModalFiltersMarkRemittanceAsPaidLogicProps) => {
    const [myFilters, setMyFilters] = useState<TwinDictionary>({})
    const [dictRemittances, setDictRemittances] = useState<TwinDictionary | null>(null)

    const getRemittances = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/accounting/collectionAndPayments/getAllRemittances', { where: {status: BankRemittanceStatusInversed['pendent']}})
        if (result) {
            setDictRemittances(dictionaryComplexFromJsonArr(result))
        }
    }, [setDictRemittances])

    const handleChangePresearchFilter = useCallback((field: string, value: string) => {
        setMyFilters((old)=>{
            let copyOld = JSON.parse(JSON.stringify(old))
            if(field=== 'from'){
                copyOld[field] = {'$gteN': new Date(value)}
            } else if (field === 'to') {
                copyOld[field] = { '$lteN': new Date(value) }
            }else {
                copyOld[field] = value
            }
            return copyOld
        })
    }, [setMyFilters])

    const readyToSearch = useCallback(() => {
        setPreSearchFilters(parsePresearchFiltersNewRemittance(myFilters))
    }, [setPreSearchFilters, myFilters])

    useEffect(() => {
        getRemittances()
    }, [getRemittances])

    return { handleChangePresearchFilter, readyToSearch, dictRemittances }
}


export default ModalFiltersMarkRemittanceAsPaid